import React from 'react';
import './Avatar.scss';

export interface AvatarProps {
  src?: string | null;
  alt?: string;
  name?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  className?: string;
}

const getInitials = (name?: string): string => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }
  return parts[0].charAt(0).toUpperCase();
};

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  name,
  size = 'medium',
  className = '',
}) => {
  const displayAlt = alt || name || 'Avatar';
  const initials = getInitials(name);

  if (src) {
    return (
      <img
        src={src}
        alt={displayAlt}
        className={`avatar avatar--${size} ${className}`}
      />
    );
  }

  return (
    <div className={`avatar avatar--${size} avatar--placeholder ${className}`}>
      <span>{initials}</span>
    </div>
  );
};

